import { UUID } from "../generic/uuid";
import { WineryDto } from "@vini-wine/core-dtos";

export interface WineryModel extends UUID {
  // transform
  name: string;
}

export const createWineryDtoFromOfferWineryModel = (
  winery: WineryModel,
): WineryDto => {
  return {
    uuid: winery.uuid,
    name: winery.name,
  };
};
